<template>
  <el-input
    ref="inputRef"
    v-model="agValue"
    :readonly="readonlyComputed"
    @mouseenter.native="mouseenter"
    @mouseleave.native="mouseleave"
    @change="handleChange"
    @focus="handleFocus"
    @blur="handleBlur"
  >
    <i slot="suffix" class="el-input__icon el-icon-search" @click="emitFocus" />
    <i
      v-show="flagHover && agValue"
      slot="suffix"
      class="el-input__icon el-icon-circle-close pointer"
      @click.stop="handleClearClick"
    />
  </el-input>
</template>

<script>
import agEditorMixins from './ag-editor-mixins'

export default {
  name: 'AgInputDialog',
  mixins: [agEditorMixins],
  props: {},
  data() {
    return {
      // 鼠标hover状态
      flagHover: false
    }
  },
  computed: {
    componentProps() {
      return Object.assign(
        {},
        {
          placeholder: this.$t('components.pleaseEnter'),
          size: 'mini'
        },
        this.params?.cellEditorComponentProps || {}
      )
    },
    readonlyComputed() {
      if (this.type === 'dialog') return true
      return this.readonly
    }
  },

  methods: {
    triggerChange() {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { change } = cellEditorComponentProps || {}

      change?.(this.agValue, {
        agParams: restAgParams
      })
    },
    triggerClear() {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { clear } = cellEditorComponentProps || {}

      clear?.(this.agValue, {
        agParams: restAgParams
      })
    },
    // 监听键盘事件
    handleKeyup(e) {
      this.triggerKeyup(e)
    },
    // 监听键盘事件
    handleKeydown(e) {
      this.triggerKeydown(e)
    },
    handleBlur(e) {
      this.triggerBlur(e)
    },
    // 聚焦事件
    handleFocus(e) {
      if (this.hasError) {
        this.popoverVisible = true
      }

      const { focusSelect } = this.componentProps

      if (focusSelect) {
        this.$nextTick(() => {
          e.target.select()
        })
      }

      this.triggerFocus(e)
    },
    mouseenter() {
      this.flagHover = true
    },
    mouseleave() {
      this.flagHover = false
    },
    handleChange() {
      this.triggerChange()
    },
    handleClearClick() {
      this.agValue = ''
      this.triggerChange()
      this.triggerClear()
    },
    focus() {
      this.$refs.inputRef.focus()
    },
    blur() {
      this.$refs.inputRef.blur()
    },
    select() {
      this.$refs.inputRef.select()
    }
  }
}
</script>
